import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../app/core/models/generic-models';
import * as proofOfBankDocumentTypesActions from '../actions';
import { IStaticDataResponse } from '../models/static-data.model';

export const proofOfBankDocumentTypesFeatureKey = 'proofOfBankDocumentTypes';

export interface ProofOfBankDocumentTypesState {
  loading: boolean;
  data: IStaticDataResponse[];
  error: any;
}

export const initialState: ProofOfBankDocumentTypesState = {
  loading: false,
  data: [],
  error: null
};

export const reducer = createReducer(
  initialState,
  on(proofOfBankDocumentTypesActions.fromProofOfBankDocumentTypesAction.loadProofOfBankDocumentTypes, state => ({ ...state, loading: true, error: null })),
  on(proofOfBankDocumentTypesActions.fromProofOfBankDocumentTypesAction.loadProofOfBankDocumentTypesSuccess, (state, { response }) => ({ ...state, loading: false, data: response, error: null })),
  on(proofOfBankDocumentTypesActions.fromProofOfBankDocumentTypesAction.loadProofOfBankDocumentTypesFailure, (state, { error }) => ({ ...state, loading: false, error }))
);

export const getProofOfBankDocumentTypes = (state: ProofOfBankDocumentTypesState) => state.data;
export const getProofOfBankDocumentTypesLoading = (state: ProofOfBankDocumentTypesState) => state.loading;
export const getProofOfBankDocumentTypesError = (state: ProofOfBankDocumentTypesState) => state.error;